import { Stack } from '@chakra-ui/react';
import * as React from 'react';

export const Container: React.FC = (props) => {
  return (
    <Stack spacing="4" flex="1">
      {props.children}
    </Stack>
  );
};
